import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ChartPointModel }           from '../typings/intelligence.chart-point';
import { ChartSeriesModel }          from '../typings/intelligence.chart-series';
import { DonutSegmentModel }         from '../typings/intelligence.donut-segment';
import { IntelligenceFormatService } from '../intelligence.format.service';

@Component({
  selector   : 'wor-intelligence-chart-card',
  template: require('./intelligence.chart-card.component.html')
})
export class ChartCardComponent {
  @Input() csvLabelHeader = this.translateService.instant('INTELLIGENCE_SPACE.COMMON.DATE');
  @Input() csvName : string;
  @Input() csvPoints : Array<ChartPointModel>;
  @Input() csvRows : Array<any>;
  @Input() csvSegments : Array<DonutSegmentModel>;
  @Input() csvSeries : Array<ChartSeriesModel>;
  @Input() description = '';
  @Input() empty = false;
  @Input() loading = false;
  @Input() title = '';

  constructor (
    private intelligenceFormatService: IntelligenceFormatService,
    private translateService         : TranslateService
  ) {}

  download () : void {
    this.intelligenceFormatService.downloadCsv(this.csvName || this.title, this.buildRows());
  }

  hasCsv () : boolean {
    return !!( ( this.csvRows && this.csvRows.length )
      || ( this.csvSegments && this.csvSegments.length )
      || ( this.csvPoints && this.csvPoints.length && this.csvSeries && this.csvSeries.length ) );
  }

  private buildRows () : Array<any> {
    if ( this.csvRows && this.csvRows.length ) {
      return this.csvRows;
    }

    if ( this.csvSegments && this.csvSegments.length ) {
      return this.csvSegments.map(segment => ({ label: segment.label, value: segment.value }));
    }

    return ( this.csvPoints || [] ).map(point => {
      const row : { [ key : string ] : any } = { [ this.csvLabelHeader ]: point.label };

      ( this.csvSeries || [] ).forEach(series => row[ series.label ] = point.values[ series.key ]);

      return row;
    });
  }
}
